import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { ReactElement } from 'react';

import { AkaDurchgangId } from '../../../dtos.js';
import { trpc } from '../../../trpc.js';
import { FehlerCell } from '../FehlerCell.js';

export const DurchgangFehlerCell = (params: GridRenderCellParams<{ akaDurchgangId: AkaDurchgangId }>): ReactElement => {
  const { data } = trpc.durchgang.getHealthByDurchgang.useQuery({
    akaDurchgangId: params.row.akaDurchgangId,
  });
  return <FehlerCell healthFindings={data} />;
};
